// snackbarSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  open: false,
  message: '',
  severity: 'info' // Default severity
};

const snackbarSlice = createSlice({
  name: 'snackbar',
  initialState,
  reducers: {
    showSnackbar: (state, action) => {
      state.open = true;
      state.message = action.payload.message;
      state.severity = action.payload.severity || 'info'; // Default to 'info' if not provided
    },
    hideSnackbar: (state) => {
      state.open = false;
      state.message = '';
      state.severity = 'info';
    }
  }
});

export const { showSnackbar, hideSnackbar } = snackbarSlice.actions;
export const selectSnackbar = (state) => state.snackbar;
export default snackbarSlice.reducer;
